```vue
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-question"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Créer une question
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une question"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                CONTENU
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                TYPE
              </th>
              
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                DATE CRÉATION
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, index) in questions" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ question.contenu }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ question.type }}
              </td>
             
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(question.createdAt) }}
              </td>
              <div class="dropdown">
                <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  Actions
                  <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                </span>
                <ul class="dropdown-menu">
                  <li v-if="checkPermission('EditQuestion')">
                    <a
                      class="dropdown-item d-flex align-items-center"
                      href="javascript:void(0);"
                      @click="editQuestion(question.id)"
                    >
                      <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                      Modifier
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item d-flex align-items-center"
                      href="javascript:void(0);"
                      @click="suppression(question.id, questions, 'questions', 'une question')"
                    >
                      <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                      Supprimer
                    </a>
                  </li>
                  
                    <router-link
                      class="dropdown-item d-flex align-items-center"
                      :to="{ name: 'ViewQuestionPage', params: { id: question.id } }"
                    >
                      <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                      Voir
                    </router-link>
                  
                </ul>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable no-undef */
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { format_date, suppression, error } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from '@/services/JwtService';
import { AxiosResponse } from 'axios';

// Interfaces locales
interface ApiResponse {
  code: number;
  data: any;
  message: string;
}

interface Question {
  id: number;
  contenu: string;
  type: string;
  
  createdAt: Date;
}

interface AxiosErrorResponse {
  data: {
    message: string;
  };
}

export default defineComponent({
  name: 'ListeQuestion',
  components: {
    PaginationComponent,
  },
  setup() {
    const router = useRouter();
    const questions = ref<Array<Question>>([]);
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const searchTerm = ref('');

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      getAllQuestions(page_, limit_, searchTerm.value);
    };

    function rechercher() {
      getAllQuestions(page.value, limit.value, searchTerm.value);
    }

    function getAllQuestions(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/questions?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }: AxiosResponse<ApiResponse>) => {
          console.log("Données reçues Tadaaaa :", data); 
          questions.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch((err: { response: AxiosErrorResponse }) => {
          error(err.response.data.message);
        });
    }

    const editQuestion = (id: number) => {
      router.push({ name: 'EditQuestionPage', params: { id } });
    };

    onMounted(() => {
      getAllQuestions();
    });

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    return {
      questions,
      checkPermission,
      format_date,
      editQuestion,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
    };
  },
});
</script>
```